import { FC, Fragment, useState } from "react";
import Dropzone from "react-dropzone";
import { H5, SVG } from "../../AbstractElements";

interface CommonFileUploadProps {
    multiple?: boolean;
    uploadedFiles: File[];
    onFileUpload: (files: File[]) => void;
    onRemoveFile: (index: number) => void;
}

const CommonFileUpload: FC<CommonFileUploadProps> = ({ multiple, uploadedFiles, onFileUpload, onRemoveFile }) => {
    // No need for local state since it's managed by the parent
    const handleDrop = (acceptedFiles: File[]) => {
        onFileUpload(acceptedFiles);
    };

    const handleRemove = (indexToRemove: number) => {
        onRemoveFile(indexToRemove);
    };

    return (
        <Fragment>
            {uploadedFiles.length === 0 ? (
                <Dropzone onDrop={handleDrop} accept={{
                    "application/vnd.ms-excel": [".xls"],
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"]
                }}>
                    {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps()} className="dropzone-container">
                            <input {...getInputProps()} />
                            <div className="dz-message">
                                <SVG iconId="file-upload1" />
                                <H5>Drag Excel Files or Click to Browse</H5>
                            </div>
                        </div>
                    )}
                </Dropzone>
            ) : (
                <Fragment>
                    {multiple && (
                        <Dropzone onDrop={handleDrop} accept={{
                            "application/vnd.ms-excel": [".xls"],
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"]
                        }}>
                            {({ getRootProps, getInputProps }) => (
                                <div {...getRootProps()} className="add-more-files-zone">
                                    <input {...getInputProps()} />
                                    <p>Click or drag more Excel files to add</p>
                                </div>
                            )}
                        </Dropzone>
                    )}

                    <div className="uploaded-files">
                        {uploadedFiles.map((file, index) => (
                            <div key={index} className="file-card">
                                {file.type.startsWith("image/") ? (
                                    <img src={URL.createObjectURL(file)} alt={file.name} className="file-thumbnail" />
                                ) : (
                                    <div className="file-placeholder">EXCEL File</div>
                                )}
                                <p className="file-name">{file.name}</p>
                                <p className="file-size">{(file.size / 1024).toFixed(2)} KB</p>
                                <button onClick={() => handleRemove(index)} className="remove-button" title="Remove file">
                                    ×
                                </button>
                            </div>
                        ))}
                    </div>
                </Fragment>
            )}
        </Fragment>
    );
};

export default CommonFileUpload;